// extracted by mini-css-extract-plugin
export default {"item":"VariablesAssigner_item__+mj42"};